<mat-card class="drawing-tools">
  <mat-card-header class="map-tools-header">Drawing Tools</mat-card-header>
  <mat-card-content>
    <mat-grid-list cols="3" rowHeight="4:3">

      <mat-grid-tile colspan="1" rowspan="1">
        <button mat-button
                matTooltip="Pan the map or cancel drawing mode"
                matTooltipPosition="above"
                aria-label="Button to pan the map or cancel drawing mode"
                class="" (click)="setDrawingMode(DrawingModes.NONE)">
          <span class="material-icons">pan_tool</span>
        </button>
      </mat-grid-tile>

      <mat-grid-tile colspan="1" rowspan="1">
        <button mat-button
                matTooltip="Draw a polyline on the map"
                matTooltipPosition="above"
                aria-label="Button to add a polyline to the map"
                class="" (click)="[setDrawingMode(DrawingModes.POLYLINE)]"><span class="material-icons">timeline</span></button>
      </mat-grid-tile>

      <mat-grid-tile colspan="1" rowspan="1">
        <button mat-button
                matTooltip="Place a point of interest on the map"
                matTooltipPosition="above"
                aria-label="Button to add a point of interest to the map"
                class=""
                (click)="[setDrawingMode(DrawingModes.MARKER)]">
          <span class="material-icons">location_on</span>
        </button>
      </mat-grid-tile>

      <mat-grid-tile colspan="1" rowspan="1">
        <button mat-button
                matTooltip="Draw a region on the map"
                aria-label="Button for drawing a region on the map"
                class=""
                (click)="[setDrawingMode(DrawingModes.POLYGON)]">
          <span class="material-icons-outlined">hexagon</span>
        </button>
      </mat-grid-tile>

      <mat-grid-tile colspan="1" rowspan="1">
        <button mat-button
                matTooltip="Edit a feature on the map"
                aria-label="Button to edit a feature on the map"
                class=""
                (click)="[setDrawingMode(DrawingModes.EDIT)]">
          <span class="material-icons">edit</span>
        </button>
      </mat-grid-tile>

      <mat-grid-tile colspan="1" rowspan="1">
        <button mat-button
                matTooltip="Delete a feature from the map"
                aria-label="Button to delete a feature from the map"
                class=""
                (click)="[setDrawingMode(DrawingModes.DELETE)]">
          <span class="material-icons">delete</span>
        </button>
      </mat-grid-tile>

      <mat-grid-tile colspan="3" rowspan="1">
        <button id="saveButton" mat-button>Save</button>
      </mat-grid-tile>

    </mat-grid-list>
  </mat-card-content>
</mat-card>

<!--mat-card class="drawing-tools">
  <mat-card-header class="map-tools-header">Go To Location</mat-card-header>
  <mat-card-content>
    <mat-grid-list cols="3" rowHeight="4:3">
      <mat-grid-tile colspan="3" rowspan="2">
        <mat-form-field>
          <mat-label>Latitude</mat-label>
          <input matInput [(ngModel)]="latitude" />
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile colspan="3" rowspan="2">
        <mat-form-field>
          <mat-label>Longitude</mat-label>
          <input matInput [(ngModel)]="longitude" />
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile colspan="1" rowspan="1">
        <button mat-button class="" (click)="[gotoHome()]"><span class="material-icons">home</span></button>
      </mat-grid-tile>
      <mat-grid-tile colspan="1" rowspan="1">
        <button mat-button class="" (click)="[]"><span class="material-icons">close</span></button>
      </mat-grid-tile>
      <mat-grid-tile colspan="1" rowspan="1">
        <button mat-button class="" (click)="[setCenter()]"><span class="material-icons">arrow_forward</span></button>
      </mat-grid-tile>
    </mat-grid-list>
  </mat-card-content>
</mat-card-->